<template lang="html">
  <div class="demoinfo">
    <h1>"Shelter basic" DEMO verzió
      <v-icon @click="$router.push('/faq')">
        mdi-frequently-asked-questions
      </v-icon>
    </h1>
    <h5>Az oldal demonstrációs célokat szolgál, ne töltsön fel személyes képeket, adatokat!</h5>

    <section>
      <h2 class="title mt-5">A DEMO verzió használata</h2>
      <p>
        Ez az oldal egy elképzelt állatmenhely honlapja, kitalált információkkal.
        A honlapon szereplő védencek adatlapjait ,valamint a híreket/eseményeket
        az arra jogosult felhasználó töltheti fel, módosíthatja, illetve törölheti.
      </p>
      <p>
        A demo verzió <span class="kiemelt">maximum 10 állat</span> adatlapját engedi feltölteni.
      </p>
    </section>


    <section>
      <h2 class="subtitle">Az adatok megadása - Védencek hozzáadása</h2>
      <p>
        Az adatlap létrehozására jogosult felhasználó az "Új védenc" gombbal hozhat létre adatlapot.
      </p>
      <div class="form-kitoltese">
        <h3 class="kiemelt mt-5">Kötelezően kitöltendő adatok:</h3>
        <ul>
          <li><span class="kiemelt"> Állat azonosítója</span> később nem változtatható!</li>
          <li><span class="kiemelt"> Állat neve</span> pl. 'Fifi'</li>
          <li><span class="kiemelt"> Állat faja</span> alapbeállítás: "eb"</li>
          <li><span class="kiemelt"> Állat ivara</span> a lebomló menüből választható, vagy beírható</li>
          <li><span class="kiemelt"> Állat kora</span> pl. '3 év', '2 hónap'</li>
        </ul>

        <h3 class="kiemelt mt-5">Nem kötelező adatok:</h3>
        <ul>
          <li><span class="kiemelt"> Fajtája</span></li>
          <li><span class="kiemelt"> Mérete, súlya</span></li>
          <li><span class="kiemelt"> Bekerülés időpontja</span>alapbeállítás: adatlap létrehozásának napja</li>
          <li><span class="kiemelt"> Védenc színkódja</span></li>
          <li><span class="kiemelt"> Kölyök-e?</span> alapbeállítás: nem</li>
          <li><span class="kiemelt"> Örökbefogadható-e?</span> alapbeállítás: nem</li>
          <li><span class="kiemelt"> Örökbeadás időpontja</span> alapbeállítás: üres</li>

          <li><span class="kiemelt"> Link a dokumentumokhoz</span></li>
          <li><span class="kiemelt"> Link, pl facebook oldalra</span></li>
          <li><span class="kiemelt"> Egyéb megjegyzés</span> pl. 'Gyermekek mellé nem ajánljuk'</li>
          <li><span class="kiemelt"> Védenc története</span> lehet hosszabb szöveg is</li>
        </ul>
        <p class="mt-5">
          A védencek színkódokkal csoportokra oszthatók, később ezekkel a kódokkal szűrhetők.
          Például a demoban a kék szín egészségügyi problémát jelöl, a piros szín pedig komoly viselkedési zavarokat.
        </p>
        <p>
          Ha az örökbeadás dátumát kitöltjük, a védenc automatikusan bekerül az örökbeadottak listájába.
        </p>
        <p>
          A feltölthető képek : 1db listakép - thumbnail - max 30kb, 3db nagykép - max 200kb.<br/>
          Amennyiben nem kerül feltöltésre legalább egy listakép, és egy nagykép, ezek helyett a rendszer
          automatikusan egy előre beállított képet használ. képet törölni nem lehet, csak másikat feltölteni helyette.
        </p>
        <p>
          Az arra jogosult felhasználó adatlapot is módosíthat, hasonló korlátozásokkal, mint a létrehozásnál.
          Ebben az esetben azonban az állat azonosítója már nem változtatható meg!
        </p>
        <p>
          Hiányos/hibás adatok esetén a rendszer hibaüzenetet küld.
        </p>
      </div>
      <p>
        Az adatlap létrehozására jogosult felhasználók kijelölhetnek egyetlen védencet (itt: 'a hét védence').
        Egyetlen állat kijelölése lehetséges egyszerre, másik állat kijelölésekor az előző kijelölése értelemszerűen megszűnik.
      </p>
    </section>

    <section class="">
      <h2 class="subtitle">Az adatok megadása - események hozzáadása</h2>
      <p>
        Az arra jogosult felhasználók híreket, eseményeket adhatnak hozzá az oldalhoz, valamint módosíthatják azokat.
        A demo felhasználóknál a jogosultságok azonosak a védencek kezeléséhez tartozó jogosultságokkal.
      </p>
      <p>
        Új eseményt létrehozni az adminisztrációs oldalon ehhez tartozó gomb megnyomásával lehet.
      </p>
      <p>
        Hírt/eseményt módosítani a hír címe mellett megjelenő 'Update' gombra kattintva lehet
        (a gomb csak erre jogosult felhasználónak jelenik meg)
      </p>
      <p>
        Ez a demo verzió nem biztosít felületet az események törléséhez.
      </p>
      <p>
        Hír/esemény létrehozásához kötelező megadni a hír
        <ul>
          <li><span class="kiemelt">Rövidített címét </span>(felületen nem látható, url készítéséhez szükséges),</li>
          <li><span class="kiemelt">Címét </span>(ez jelenik meg a listázási sávon)</li>
          <li><span class="kiemelt">Szöveges tartalmát</span></li>
        </ul>
      </p>
      <p>
        Ezeken kívül megadható még:
        <ul>
          <li><span class="kiemelt">az esemény dátuma </span> (ennek megfelelően jeleníti meg közelgő eseményként az oldal)</li>
          <li><span class="kiemelt">1 darab kép</span> (max 200KB)</li>
          <li><span class="kiemelt">1-1 link a dokumentumokhoz / facebookhoz</span></li>
        </ul>
      </p>
    </section>

    <section class="">
      <h2 class="subtitle">Felhasználók, bejelentkezés</h2>
      <p>
        Felhasználót létrehozni és a jogosultságait beállítani csak a backend admin oldaláról lehet.
        A felhasználó az utolsó bejelentkezés után 2 óra múlva automatikusan kijelentkeztetésre kerül az oldal frissítésekor (ez munkamenetet nem szakít meg).
        Az oldal használatának befejezésekor ennek ellenére javasolt a kilépés.
      </p>

      <p>
        Bejelentkezni a navigációs sávon található 'ADMINISZTRÁCIÓ' fülön lehet. <br/>
        Az oldal admininsztrációs részére bármikor visszaléphetünk a felső sorban található felhasználónévre kattintással.
        A felhasználónév melletti ikonra kattintás kilépteti a felhasználót.<br/>
        A DEMO verzió használatához előre beállításra kerültek a következő felhasználók:
      </p>
    </section>



      <v-card color="transparent" raised max-width=300 class="my-5">
        <v-card-title>gyepmester</v-card-title>
        <div class="subtitle">Jelszó: "gyepi123"</div>
        <v-card-text>Joga van: állatot/eseményt létrehozni, módosítani, törölni</v-card-text>
      </v-card>

      <v-card color="transparent" raised max-width=300 class="my-5">
        <v-card-title>gyephelper</v-card-title>
        <div class="subtitle">Jelszó: "user1234"</div>
        <v-card-text>Joga van: állatot/eseményt létrehozni</v-card-text>
      </v-card>

      <v-card color="transparent" raised max-width=300 class="my-5">
        <v-card-title>basicuser</v-card-title>
        <div class="subtitle">Jelszó: "user1234"</div>
        <v-card-text>Jogosultság nélküli felhasználó.</v-card-text>
      </v-card>


  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.demoinfo{
  width: 90%;
  margin: 0 auto;
  text-align: center;

  section{
    margin-bottom: 40px;
  }

  p{
    text-align: justify;
  }

  h2{
    margin-bottom: 10px;
  }
}
.form-kitoltese span.kiemelt{
  display:block;
}
.kiemelt{
  font-weight: bold;
  color: $darkbrown;
}

.form-kitoltese ul{
      margin: 0 auto;
      list-style-type: none;
      max-width: 500px;
      padding-left: 0;
}

.v-card {
  margin: 0 auto;

  .subtitle{
    text-align: left;
    padding: 0px 16px;
  }
  .v-card__text{
    text-align: left;
    padding: 16px;
  }
}
</style>
